/* eslint-disable @typescript-eslint/no-require-imports */
import { ImageRequireSource } from 'react-native';

export type TrackerTextureMapType = typeof TrackerTextureMap;

const TrackerTextureMap = {
  SEAFOAM:
    require('assets/images/vxl/component/tracker/tracker-bar-fill-seafoam.png') as ImageRequireSource,
  PINK: require('assets/images/vxl/component/tracker/tracker-bar-fill-pink.png') as ImageRequireSource,
  GREY_A:
    require('assets/images/vxl/component/tracker/tracker-bar-fill-grey-a.png') as ImageRequireSource,
  GREY_B:
    require('assets/images/vxl/component/tracker/tracker-bar-fill-grey-b.png') as ImageRequireSource,
  PURPLE:
    require('assets/images/vxl/component/tracker/tracker-bar-fill-purple.png') as ImageRequireSource,
} satisfies Record<string, ImageRequireSource>;

export default TrackerTextureMap;
